import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import { RecoilRoot } from 'recoil';

import GrowMe from './grow-me';

import './index.css';
import './styles/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
// Rediseño visual: después de Bootstrap para que sus reglas no lo pisen.
import './styles/theme/skin.scss';
import 'tippy.js/dist/tippy.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <RecoilRoot>
      <GrowMe />
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
